// extracted by mini-css-extract-plugin
export default {"header":"OrderCancellationOptions--header--df37f1","button":"OrderCancellationOptions--button--f04606"};